export default "__VITE_ASSET__5a732849__"